import angular from 'angular';
import 'angular-ui-router';
import 'ng-file-upload/dist/ng-file-upload';
import 'angular-modal-service';
import Filters from '../../filters/filters';
import template from './audioCreativesForm.jade';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import FiltersModule from '../../filters/filters';

export class AudioCreativesFormController {
  /* @ngInject */
  constructor($scope, currentGame, $filter, ModalService, Upload, $stateParams, GamesResource, setProgressBar, notify, $sce) {
    this.$scope = $scope;
    this.$sce = $sce;
    this.ModalService = ModalService;
    this.currentGame = currentGame;
    this.GamesResource = GamesResource;
    this.$stateParams = $stateParams;
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.Upload = Upload;
    this.setProgressBar = setProgressBar;
    this.notify = notify;
    this.statusOptions =	[
      {name: 'active', value: true},
      {name: 'inactive', value: false}
    ];
    this.validFileTypes = [ 'image/png',
      'image/jpeg',
      'image/pjpeg',
      'image/gif'
    ];

    this.isEditingCompanionAds = false;
    this.isCompanionAdsLoaded = false;
    this.allowedCompanionAdSizes = [
      '1024x768',
      '768x1024',
      '480x320',
      '320x480',
      '300x250',
      '400x400'
      ];

    this.endGameTypes =	[
      {name: 'Static', value: 'static'},
      {name: '480x320 MRAID Banner', value:'480x320 MRAID Banner', dimensions: {w: 480, h: 320}},
      {name: '320x480 MRAID Banner', value:'320x480 MRAID Banner', dimensions: {w: 320, h: 480}},
    ];

    this.mraidApiFrameworks =	[
      {name: 'MRAID-1', value: 3},
      {name: 'MRAID-2', value: 5},
      {name: 'MRAID-3', value: 6}
    ];

    this.mraidCompanions = _.filter(this.creative.companion_ads, ca => ca.companion_ad_type === 'mraid_banner') || {};
    this.endGameType = 'static';
    this.mainAudioSafeUrl =
          this.$sce.trustAsResourceUrl(this.audioAdMainAudioUrl);

    this.thumbnailImageSafeUrl = this.$sce.trustAsResourceUrl("https://upload.wikimedia.org/wikipedia/commons/2/21/Speaker_Icon.svg");


    if (!this.creative.companionAdsMap) {
      this.creative.companionAdsMap = {};
    }

    if(!this.creative.id) {
      this.creative.active = true;
    }
  }

  showPreviewModal(res, width, height){
    this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++">
            <iframe ng-src="{{vm.res}}" style='margin-top: 75px;' width="{{vm.width}}" height="{{vm.height}}" frameborder='0'"/>
            <svg gg-icon='icon-close' style='position: absolute; margin-top: 50px;' width="25" height="25"/>
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.res = res;
        this.width = width;
        this.height = height;
        this.close = close;
      }
    });
  }

  openMraidPreview(mraidCompanion){
    let [width, height] = (mraidCompanion.size || '750x650').split('x').map(v => parseInt(v, '10'));
    let mraidPreviewUrl = this.$sce.trustAsResourceUrl("https://bidder.dsp.youappi.com/creative/preview/" + this.creative.id + "/" + mraidCompanion.id);
    this.showPreviewModal(mraidPreviewUrl, width, height);
  }

  fetchCompanionAds() {
      this.GamesResource.one(this.$stateParams.gameId)
      .one('variations', this.creative.variation_id)
      .one('creatives', this.creative.id)
      .getList('companion-ads')
      .then((companionAdsResult) => {
        this.creative.companionAdsMap = this.getDeserialisedCompanionAdsMap(companionAdsResult);
      });
  }

  showCompanionAds() {
    if (!this.isCompanionAdsLoaded) {
      this.fetchCompanionAds();
      this.isCompanionAdsLoaded = true;
    }
    this.isEditingCompanionAds = !this.isEditingCompanionAds;
  }

  removeCreative() {
    if (!this.creative.id) {
      let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.type == this.creative.type;});
      if (indexOfCreativeToRemove > -1) {
        this.variation.creatives.splice(indexOfCreativeToRemove,1);
      }
    } else {
      this.creative.is_deleted = true;
      this.creative.companion_ads = [];
      return this.GamesResource.one(this.$stateParams.gameId).one('variations', this.creative.variation_id).one('creatives', this.creative.id).customPUT(this.creative)
          .then((creativeRes) => {
            let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.id == this.creative.id;});
            if (indexOfCreativeToRemove > -1) {
              this.variation.creatives.splice(indexOfCreativeToRemove,1);
            }
          });
    }
  }

  get creatives() {
    return _.chain(this.variation).map('creatives').flatten().value();
  }

  get companionAdsIds() {
    const ids = _.compact(_.map(_.values(this.creative.companionAdsMap), v => v.id));
    return (_.isEmpty(ids) || ids.length > 1) ? '' : `(${_.map(ids, v => `#${v}`).join(', ')})`;
  }

  get companionAd1024x768Url() {
    return _.get(this.creative.companionAdsMap, '_1024x768.url') || _.get(this.creative.companionAdsMap, '_1024x768.file.$ngfBlobUrl');
  }

  get companionAd768x1024Url() {
    return _.get(this.creative.companionAdsMap, '_768x1024.url') || _.get(this.creative.companionAdsMap, '_768x1024.file.$ngfBlobUrl');
  }

  get companionAd480x320Url() {
    return _.get(this.creative.companionAdsMap, '_480x320.url') || _.get(this.creative.companionAdsMap, '_480x320.file.$ngfBlobUrl');
  }

  get companionAd320x480Url() {
    return _.get(this.creative.companionAdsMap, '_320x480.url') || _.get(this.creative.companionAdsMap, '_320x480.file.$ngfBlobUrl');
  }

  get companionAd300x250Url() {
    return _.get(this.creative.companionAdsMap, '_300x250.url') || _.get(this.creative.companionAdsMap, '_300x250.file.$ngfBlobUrl');
  }

  get companionAd400x400Url() {
    return _.get(this.creative.companionAdsMap, '_400x400.url') || _.get(this.creative.companionAdsMap, '_400x400.file.$ngfBlobUrl');
  }

  get companionAd1024x768Id() {
    return _.get(this.creative.companionAdsMap, '_1024x768.id') || '';
  }

  get companionAd768x1024Id() {
    return _.get(this.creative.companionAdsMap, '_768x1024.id') || '';
  }

  get companionAd480x320Id() {
    return _.get(this.creative.companionAdsMap, '_480x320.id') || '';
  }

  get companionAd320x480Id() {
    return _.get(this.creative.companionAdsMap, '_320x480.id') || '';
  }

  get companionAd300x250Id() {
    return _.get(this.creative.companionAdsMap, '_300x250.id') || '';
  }

  get companionAd400x400Id() {
    return _.get(this.creative.companionAdsMap, '_400x400.id') || '';
  }

  handleNewMRaidCompanionFile(mraidCompanionFile){
    const selectedEngGameInfo = _.find(this.endGameTypes, e => e.value === this.endGameType)
    let dimensionsString = selectedEngGameInfo.dimensions.w + 'x' + selectedEngGameInfo.dimensions.h;
    let key = 'mraid_'+dimensionsString;

    if (!(key in this.creative.companionAdsMap)) {
      this.creative.companionAdsMap[key] = {};
    }
    this.creative.companionAdsMap[key].url = null;
    this.creative.companionAdsMap[key].file = mraidCompanionFile;
    this.creative.companionAdsMap[key].size = dimensionsString;
    this.creative.companionAdsMap[key].media_type = mraidCompanionFile.type;
    this.creative.companionAdsMap[key].companion_ad_type = 'mraid_banner';
    this.creative.companionAdsMap[key].api_framework = this.mraidApiFrameworkValue;
  }

  onExistingMraidApiFramworkChange(mraidCompanion) {
    this.creative.companionAdsMap['mraid_'+mraidCompanion.size].api_framework = mraidCompanion.api_framework;
  }

  onExistingMraidDefinitionChange(mraidCompanion) {
    this.creative.companionAdsMap['mraid_'+mraidCompanion.size].definition = mraidCompanion.definition;
  }

  onMraidApiFramworkChange(value) {
    const selectedEngGameInfo = _.find(this.endGameTypes, e => e.value === this.endGameType)
    let dimensionsString = selectedEngGameInfo.dimensions.w + 'x' + selectedEngGameInfo.dimensions.h;
    let key = 'mraid_'+dimensionsString;

    if (!(key in this.creative.companionAdsMap)) {
      this.creative.companionAdsMap[key] = {};
    }
    this.creative.companionAdsMap[key].api_framework = value;

  }

  handleNewCompanionAd(image) {
    if(image) {
      if(_.indexOf(this.validFileTypes, image.type) > -1) {
        this.Upload.imageDimensions(image).then((dimensions) => {
          let dimensionsString = dimensions.width + 'x' + dimensions.height;
          if(_.intersection(this.allowedCompanionAdSizes, [dimensionsString]).length > 0){
            let key = '_'+dimensionsString;
            if (!(key in this.creative.companionAdsMap)) {
              this.creative.companionAdsMap[key] = {};
            }
            this.creative.companionAdsMap[key].url = null;
            this.creative.companionAdsMap[key].file = image;
            this.creative.companionAdsMap[key].size = dimensionsString;
            this.creative.companionAdsMap[key].media_type = image.type;
            this.creative.companionAdsMap[key].companion_ad_type = 'banner';
          } else {
            this.notify.warning('dimensionInvalidExpected', {dimension: dimensionsString, expected: '1024x768/768x1024/480x320/320x480'});
          }
        });
      } else {
        this.notify.warning('fileTypeInvalid', {type: image.type});
      }
    }
  }

  handleAudioMetadata(thumbAudioPlayer){
      thumbAudioPlayer.addEventListener('canplay', function() {
          this.currentTime = 1;
      });
    }

  handleNewMainAudio(mainAudio){
    this.isLoadingMainAudio = true;
    if (mainAudio){

      var thumbAudioPlayer = document.getElementById('thumb_audio_player');
        thumbAudioPlayer.addEventListener('loadedmetadata', this.handleAudioMetadata.bind(this, thumbAudioPlayer));

      this.mainAudioSafeUrl =
        this.$sce.trustAsResourceUrl((window.URL || window.webkitURL).createObjectURL(mainAudio));

      this.$scope.$emit('newFileUploaded', mainAudio, this.creative, 'mainAudio');
      this.setProgressBar(this, 1, 1).then(() => this.isLoadingMainAudio = false);
    }
  }

  get audioAdMainAudioUrl() {
    return this.creative.url || _.get(this.creative, 'mainAudio')
  }

  openAdMainAudioPreview(){
      this.showAudioPreviewModal(this.mainAudioSafeUrl);
  }

  showAudioPreviewModal(url){
    this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++" style='position: relative;'>
            <audio ng-src="{{vm.url}}" controls width='600px' ng-click="$event.stopPropagation()" style='margin-top: 15px;'/>
            <svg gg-icon='icon-close' style='position: absolute;' width="25" height="25"/>
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.url = url;
        this.close = close;
      }
    });
  }

  openAdEndCardPreview(url) {
    this.showPreviewModalUrlOnly(url);
  }

  showPreviewModalUrlOnly(url){
    this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++">
            <img ng-src="{{vm.url | adaptNonCDNHttpsUrls}}" style='margin-top: 15px;'/>
            <svg gg-icon='icon-close' style='position: absolute;' width="25" height="25"/>
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.url = url;
        this.close = close;
      }
    });
  }

  getDeserialisedCompanionAdsMap(companionAds) {
    let companionAdMapBuilder = {};
    _.forEach(companionAds, (companionAd) => {
      if (companionAd.companion_ad_type === 'banner') {
        companionAdMapBuilder['_'+companionAd.size] = companionAd;
      } else if (companionAd.companion_ad_type === 'mraid_banner') {
        companionAdMapBuilder['mraid_'+companionAd.size] = companionAd;
      }
    });

    _.forEach(this.allowedCompanionAdSizes, (allowedCompanionAdSize) => {
      if(!companionAdMapBuilder['_'+allowedCompanionAdSize]) {
        companionAdMapBuilder['_'+allowedCompanionAdSize] = {};
      }
    });

    return companionAdMapBuilder;
  }

  getSerializeCompanionAds() {
    let creativeId = this.creative.id;
    var arrayWithAllProperties = [];

    _.forEach(this.creative.companionAdsMap, (companionAd) => {
      arrayWithAllProperties.push({
        id: companionAd.id,
        size: companionAd.size,
        url: companionAd.url,
        s3_url: companionAd.s3_url,
        audio_creative_id: creativeId
      });
    });

    return _.map(arrayWithAllProperties, (obj) => {
      return _.pick(obj, ['id', 'size', 'url', 's3_url', 'audio_creative_id']);
    });
  }

}

let AudioCreativesFormComponent = {
  template: () => { return template },
  controller: AudioCreativesFormController,
  controllerAs: 'vm',
  bindings: {
    creative: '=',
    variation: '=',
    disableField: '='
  }
};

export default angular.module('app.components.campaigns.audioCreativesForm', [
  ConfigsModule.name,
  ServicesModule.name,
  Filters.name,
  FiltersModule.name,
  'angularModalService'
])
  .component('audioCreativesForm', AudioCreativesFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/audioCreativesForm.js
 **/